import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import Home from './pages/Home/Home';
import About from './pages/About/About';
import Services from './pages/Services/Services';
import Testimonials from './pages/Testimonials/Testimonials';
import Contact from './pages/Contact/Contact';
import PesoEngineering from './pages/PesoEngineering/PesoEngineering';
import ArchitecturalPlan from './pages/ArchitecturalPlan/ArchitecturalPlan';
import ForestClearance from './pages/ForestClearance/ForestClearance';
import EnvironmentalClearance from './pages/EnvironmentalClearance/EnvironmentalClearance';
import ConsentToEstablish from './pages/ConsentToEstablish/ConsentToEstablish';
import ConsentToOperate from './pages/ConsentToOperate/ConsentToOperate';
import HazardousWasteLicensing from './pages/HazardousWasteLicensing/HazardousWasteLicensing';
import BioMedicalWasteAuthorization from './pages/BioMedicalWasteAuthorization/BioMedicalWasteAuthorization.js';
import FireLicensing from './pages/FireLicensing/FireLicensing.js';
import ClinicalEstablishmentLicensing from './pages/ClinicalEstablishmentLicensing/ClinicalEstablishmentLicensing.js';
import FireNocs from './pages/FireNocs/FireNocs.js';
import Cgwanoc from './pages/CGWANOC/Cgwanoc.js';
import AirportHeightClearanceNOC from './pages/AirportHeightClearanceNOC/AirportHeightClearanceNOC.js';
import WaterAllocationOrderNOC from './pages/WaterAllocationOrderNOC/WaterAllocationOrderNOC.js';
import VariousGovtOfficialsNOCs from './pages/VariousGovtOfficialsNOCs/VariousGovtOfficialsNOCs.js';
import FeasibilityStudy from './pages/FeasibilityStudy/FeasibilityStudy.js';
import EIA from './pages/EIA/EIA.js';
import TankTesting from './pages/TankTesting/TankTesting.js';
import PesoCompliance from './pages/PesoCompliance/PesoCompliance.js';
import ForestClearanceCompliance from './pages/ForestClearanceCompliance/ForestClearanceCompliance.js';
import EnvironmentalClearanceCompliance from './pages/EnvironmentClearanceCom/EnvironmentClearanceCom.js';
import ConsentToOperateCompliance from './pages/ConsentToOperateCompliance/ConsentToOperateCompliance.js';
import CGWACompliance from './pages/CGWACompliance/CGWACompliance.js';
import Rough from './pages/Rough/Rough.js';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/about",
    element: <About />

  },
  {
    path: "/services",
    element: <Services />
  },
  {
    path: "/testimonials",
    element: <Testimonials />
  },
  {
    path: "/contact-us",
    element: <Contact />
  },
  {
    path: "/peso",
    element: <PesoEngineering />
  },
  {
    path: "/architectural-design",
    element: <ArchitecturalPlan />
  },
  {
    path: "/forest-clearance",
    element: <ForestClearance />
  },
  {
    path: "/environmental-clearance",
    element: <EnvironmentalClearance />
  }
  , {
    path: "/consent-to-estalish",
    element: <ConsentToEstablish />
  },
  {
    path: "/consent-to-operate",
    element: <ConsentToOperate />
  },
  {
    path: "/hazardous-waste-licensing",
    element: <HazardousWasteLicensing />
  },
  {
    path: "/bio-medical-waste-authorization",
    element: <BioMedicalWasteAuthorization />
  },
  {
    path: "/fire-licensing",
    element: <FireLicensing />
  },
  {
    path: "/clinical-establishment-licensing",
    element: <ClinicalEstablishmentLicensing />
  }
  , {

    path: "/fire-nocs",
    element: <FireNocs />
  },
  {
    path:"/cgwanoc",
    element: <Cgwanoc/>
  },
  {
    path:"/airport-height-clearance-noc",
    element:<AirportHeightClearanceNOC/>
  },
  {
    path:"/water-allocatio-norder-noc",
    element:<WaterAllocationOrderNOC/>
  },
  {
    path:"/various-govt-officials-nocs",
    element: <VariousGovtOfficialsNOCs/>
  },
  {
    path:"/feasibility-study-for-construction",
    element:<FeasibilityStudy/>
  },
  {
    path:"/environment-impact-assesment",
    element:<EIA/>
  },
  {
    path:"/tank-testing-certificate",
    element:<TankTesting/>
  },
  {
    path:"/peso-compliance",
    element:<PesoCompliance/>
  },
  {
    path:"/forest-clearance-compliance",
    element:<ForestClearanceCompliance/>
  },
  {
    path:"/environment-clearance-compliance",
    element:<EnvironmentalClearanceCompliance/>
  },
  {
    path:"/consent-to-operate-compliance",
    element:<ConsentToOperateCompliance/>
  },
  {
    path:"/cgwa-compliance",
    element:<CGWACompliance/>
  },
  {
    path:"/rough",
    element:<Rough/>
  }

]);



function App() {
  return (
    <>

      <RouterProvider router={router} />



    </>
  );
}

export default App;
